module.exports = __webpack_public_path__ + "img/my-ticket.0c9b1900.svg";